export default {"src":"/_next/static/media/apple=pay-payment-logo.a3af781d.svg","height":20,"width":45,"blurWidth":0,"blurHeight":0};